// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"21ca73db","249":"7649ad0d","394":"1ec35026","453":"45fefcf9","623":"6672dc20","873":"c42d6192","974":"feb13cc6"}[chunkId] + ".chunk.js";
};